<app-layout>
  <div class="row">
    <div class="col-12">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Talepler (Durumu: {{durumText}})</h3>
          <div class="card-options">
            <!-- <div class="btn btn-sm btn-pill btn-success" (click)="new()">Yeni Talep</div> -->
          </div>
        </div>
        <div class="card-body border-bottom py-3">
          <div class="d-flex">
            <div class="mr-auto text-muted">
              Arama yap:
              <div class="ml-2 d-inline-block">
                <div class="input-icon mb-3">
                  <span class="input-icon-addon" style="left:auto;right:0;" *ngIf="talepAraLoading">
                    <div class="spinner-border spinner-border-sm text-muted" role="status"></div>
                  </span>
                  <input name="kalemAra" [autocomplete]="true" type="text" class="form-control form-control-sm"
                    [(ngModel)]="talepAraText" placeholder="Yazın ve Enter'a basın"
                    (keyup.enter)="talepAraInputChange()">
                </div>
              </div>
            </div>
            <div class="text-muted">
              Gösterilen
              <div class="mx-2 d-inline-block">
                <select class="form-control form-control-sm" [(ngModel)]="showSearchResultCountTalep"
                  (change)="talepAraInputChange()">
                  <option *ngFor="let p of showSearchResultCountModelTalep" [ngValue]="p">{{p}}</option>
                </select>
              </div>
              sonuç sayısı
            </div>
          </div>
        </div>
        <app-talep-liste *ngIf="sourceTalep" [source]="sourceTalep.results" (updateTalepler)="getTalepler()">
        </app-talep-liste>
        <div class="card-footer d-flex align-items-center" *ngIf="sourceTalep">
          <p class="m-0 text-muted"><span>{{sourceTalep.rowCount}}
              sonuçtan {{sourceTalep.firstRowOnPage}}</span>-<span>{{sourceTalep.lastRowOnPage}}</span> arası sonuçlar
          </p>
          <ul class="pagination m-0 ml-auto">
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPageTalep === 1}">
              <div class="page-link" tabindex="-1" (click)="showPreviousPageSearchResultsTalep()">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="15 6 9 12 15 18"></polyline>
                </svg>
                önceki
              </div>
            </li>
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPageTalep === sourceTalep.pageCount}">
              <div class="page-link" (click)="showNextPageSearchResultsTalep()">
                sonraki
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="9 6 15 12 9 18"></polyline>
                </svg>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="card p-0">
        <div class="card-header align-items-center justify-content-between">
          <h3 class="card-title w-100">Teklifler</h3>
          <button [class]="orderByTeklifler ? 'btn-primary':'btn-secondary'" class="btn btn-sm text-nowrap" (click)="orderTeklifler()">
              {{orderByTeklifler ? 'Tümünü Getir' : 'Sadece Sipariş Verilebilecekleri Getir'}}
          </button>
        </div>
        <div class="card-body border-bottom py-3">
          <div class="d-flex">
            <div class="mr-auto text-muted">
              Arama yap:
              <div class="ml-2 d-inline-block">
                <div class="input-icon mb-3">
                  <span class="input-icon-addon" style="left:auto;right:0;" *ngIf="teklifAraLoading">
                    <div class="spinner-border spinner-border-sm text-muted" role="status"></div>
                  </span>
                  <input name="kalemAra" [autocomplete]="true" type="text" class="form-control form-control-sm"
                    [(ngModel)]="teklifAraText" placeholder="Yazın ve Enter'a basın"
                    (keyup.enter)="teklifAraInputChange()">
                </div>
              </div>
            </div>
            <div class="text-muted">
              Gösterilen
              <div class="mx-2 d-inline-block">
                <select class="form-control form-control-sm" [(ngModel)]="showSearchResultCountTeklif"
                  (change)="teklifAraInputChange()">
                  <option *ngFor="let p of showSearchResultCountModelTeklif" [ngValue]="p">{{p}}</option>
                </select>
              </div>
              sonuç sayısı
            </div>
          </div>
        </div>
        <app-talep-liste *ngIf="sourceTeklif" [source]="sourceTeklif.results" [isTeklif]="sourceTeklif.isTeklif"></app-talep-liste>
        <div class="card-footer d-flex align-items-center" *ngIf="sourceTeklif">
          <p class="m-0 text-muted"><span>{{sourceTeklif.rowCount}}
              sonuçtan {{sourceTeklif.firstRowOnPage}}</span>-<span>{{sourceTeklif.lastRowOnPage}}</span> arası sonuçlar
          </p>
          <ul class="pagination m-0 ml-auto">
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPageTeklif === 1}">
              <div class="page-link" tabindex="-1" (click)="showPreviousPageSearchResultsTeklif()">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="15 6 9 12 15 18"></polyline>
                </svg>
                önceki
              </div>
            </li>
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPageTeklif === sourceTeklif.pageCount}">
              <div class="page-link" (click)="showNextPageSearchResultsTeklif()">
                sonraki
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="9 6 15 12 9 18"></polyline>
                </svg>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

     <!-- <div class="col-12">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Sipariş Verilebilecekler</h3>
        </div>
        <div class="card-body border-bottom py-3">
          <div class="d-flex">
            <div class="mr-auto text-muted">
              Arama yap:
              <div class="ml-2 d-inline-block">
                <div class="input-icon mb-3">
                  <span class="input-icon-addon" style="left:auto;right:0;" *ngIf="teklifAraLoading2">
                    <div class="spinner-border spinner-border-sm text-muted" role="status"></div>
                  </span>
                  <input name="kalemAra" [autocomplete]="true" type="text" class="form-control form-control-sm"
                    [(ngModel)]="teklifAraText2" placeholder="Yazın ve Enter'a basın"
                    (keyup.enter)="teklifAraInputChange2()">
                </div>
              </div>
            </div>
          </div>
        </div>
        <app-talep-liste *ngIf="sourceTeklif2" [source]="sourceTeklif2" [isTeklifSiparis]="isTeklifSiparis"></app-talep-liste>
      </div>
    </div>  -->
  </div>
</app-layout>